document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('cart-drawer');
  const cartIcon = document.getElementById('cart-icon-bubble');
  const mobileCart = document.querySelector('[data-ln-cart-mobile]');
  if (!drawer || !mobileCart) return;
  mobileCart.addEventListener('click', (event) => {
    event.preventDefault();
    drawer.open(mobileCart);
  });
  if (!cartIcon) return;
  const updateMobileCount = () => {
    const bubble = cartIcon.querySelector('.cart-count-bubble');
    const countNode = bubble?.querySelector('span[aria-hidden="true"]');
    const count = countNode?.textContent?.trim() || (bubble ? '1' : '0');
    let badge = mobileCart.querySelector('span');
    if (count !== '0') {
      if (!badge) {
        badge = document.createElement('span');
        mobileCart.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
    mobileCart.setAttribute('aria-label', 'Basket, ' + count + ' items');
    cartIcon.setAttribute('aria-label', 'Basket, ' + count + ' items');
  };
  const watcher = new MutationObserver(updateMobileCount);
  watcher.observe(cartIcon, { childList: true, subtree: true });
  updateMobileCount();
});